export const getVideoUrl = (video: string): string => {
    return `${process.env.REACT_APP_ORIGIN}/videos/${video}`;
};